<div class="project-nav-header">
  <div class="project-nav-header__inner">
    <div class="project-nav-header__project">
      <div
        class="project-nav-header__icon-wrap"
        [style.background]="'color-mix(in srgb, ' + projectIconColor() + ' 10%, transparent)'"
        [style.color]="projectIconColor()"
      >
        <mat-icon fontSet="material-icons-outlined" aria-hidden="true">{{ projectIconMat() }}</mat-icon>
      </div>
      <div class="project-nav-header__text">
        <span class="project-nav-header__eyebrow">{{ 'dashboard.projectLabel' | translate }}</span>
        <h2 class="project-nav-header__name">{{ projectName() }}</h2>
      </div>
      @if (canManageProject()) {
        <button
          type="button"
          class="project-nav-header__settings-btn"
          data-testid="project-settings-btn"
          [attr.aria-label]="'projectNav.settings' | translate"
          [attr.title]="'projectNav.settings' | translate"
          (click)="openSettings()"
        >
          <mat-icon fontSet="material-icons-outlined" aria-hidden="true">settings</mat-icon>
        </button>
      }
    </div>
    <nav class="project-nav" [attr.aria-label]="'buttonToggleGroup.ariaLabel' | translate">
      <button
        type="button"
        class="project-nav__tab"
        [class.project-nav__tab--active]="isActive('requirements')"
        [attr.aria-current]="isActive('requirements') ? 'page' : null"
        [routerLink]="['/projects', projectId, 'requirements']"
      >
        <mat-icon aria-hidden="true">check</mat-icon>
        {{ 'buttonToggleGroup.requirements' | translate }}
      </button>
      <button
        type="button"
        class="project-nav__tab"
        [class.project-nav__tab--active]="isActive('test-cases')"
        [attr.aria-current]="isActive('test-cases') ? 'page' : null"
        [routerLink]="['/projects', projectId, 'test-cases']"
      >
        <mat-icon aria-hidden="true">folder</mat-icon>
        {{ 'buttonToggleGroup.testCase' | translate }}
      </button>
      <button
        type="button"
        class="project-nav__tab"
        [class.project-nav__tab--active]="isActive('test-modules')"
        [attr.aria-current]="isActive('test-modules') ? 'page' : null"
        [routerLink]="['/projects', projectId, 'test-modules']"
      >
        <mat-icon aria-hidden="true">content_copy</mat-icon>
        {{ 'buttonToggleGroup.module' | translate }}
      </button>
      <button
        type="button"
        class="project-nav__tab"
        [class.project-nav__tab--active]="isActive('test-plans')"
        [attr.aria-current]="isActive('test-plans') ? 'page' : null"
        [routerLink]="['/projects', projectId, 'test-plans']"
      >
        <mat-icon aria-hidden="true">assignment</mat-icon>
        {{ 'buttonToggleGroup.testPlan' | translate }}
      </button>
      <button
        type="button"
        class="project-nav__tab"
        [class.project-nav__tab--active]="isActive('testdatenblaetter')"
        [attr.aria-current]="isActive('testdatenblaetter') ? 'page' : null"
        [routerLink]="['/projects', projectId, 'testdatenblaetter']"
      >
        <mat-icon aria-hidden="true">table_chart</mat-icon>
        {{ 'buttonToggleGroup.testdatenblatt' | translate }}
      </button>
      <button
        type="button"
        class="project-nav__tab"
        data-testid="project-header-tab-object-mappings"
        [class.project-nav__tab--active]="isActive('object-mappings')"
        [attr.aria-current]="isActive('object-mappings') ? 'page' : null"
        [routerLink]="['/projects', projectId, 'object-mappings']"
      >
        <mat-icon aria-hidden="true">widgets</mat-icon>
        {{ 'buttonToggleGroup.objectMappings' | translate }}
      </button>
      <button
        type="button"
        class="project-nav__tab"
        data-testid="project-header-tab-testausfuehrung"
        [class.project-nav__tab--active]="isActive('test-runs')"
        [attr.aria-current]="isActive('test-runs') ? 'page' : null"
        [routerLink]="['/projects', projectId, 'test-runs']"
      >
        <mat-icon aria-hidden="true">play_circle</mat-icon>
        {{ 'buttonToggleGroup.testRun' | translate }}
      </button>
      <button
        type="button"
        class="project-nav__tab"
        [class.project-nav__tab--active]="isActive('test-results')"
        [attr.aria-current]="isActive('test-results') ? 'page' : null"
        [routerLink]="['/projects', projectId, 'test-results']"
      >
        <mat-icon aria-hidden="true">bar_chart</mat-icon>
        {{ 'buttonToggleGroup.testResults' | translate }}
      </button>
      <button
        type="button"
        class="project-nav__tab"
        data-testid="project-header-tab-defects"
        [class.project-nav__tab--active]="isActive('defects')"
        [attr.aria-current]="isActive('defects') ? 'page' : null"
        [routerLink]="['/projects', projectId, 'defects']"
      >
        <mat-icon aria-hidden="true">bug_report</mat-icon>
        {{ 'defect.list.breadcrumb' | translate }}
      </button>
    </nav>
  </div>
</div>
